import { render, staticRenderFns } from "./speakDiscussion.vue?vue&type=template&id=70c81906&scoped=true"
import script from "./speakDiscussion.vue?vue&type=script&lang=js"
export * from "./speakDiscussion.vue?vue&type=script&lang=js"
import style0 from "./speakDiscussion.vue?vue&type=style&index=0&id=70c81906&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c81906",
  null
  
)

export default component.exports